import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { usePublicBoardPage } from "~/components/Layouts/PublicBoardLayout/hooks/usePublicBoardPage";
import { usePublicWorkspace } from "~/components/PublicWorkspaceProvider";
import { PublicBoard } from "~/components/v2/components/board/PublicBoard";
import { useURLBoardIdSelector } from "~/hooks/useURLBoardIdSelector";
import { setCentralizedPublicBoardAction } from "~/store/centralizedBoard/actions";
import { useWorkspaces } from "~/swr-hooks/workspaces/useWorkspaces";
export const PublicBoardPage = /*#__PURE__*/ memo(()=>{
    const dispatch = useDispatch();
    const { data: workspaces } = useWorkspaces();
    const { workspaceId } = usePublicWorkspace();
    const boardId = useURLBoardIdSelector();
    const [isVisitBannerVisible, setVisitBannerVisible] = useState(()=>{
        if (!workspaces || !workspaceId) return false;
        return workspaces.some((workspace)=>workspace.id === workspaceId);
    });
    useEffect(()=>{
        if (isVisitBannerVisible || !workspaceId || !workspaces) return;
        setVisitBannerVisible(workspaces.some((workspace)=>workspace.id === workspaceId));
    }, [
        workspaceId,
        isVisitBannerVisible,
        workspaces
    ]);
    // Fetch board data when boardId changes
    const { data: board } = usePublicBoardPage({
        boardId: boardId || "",
        initialData: undefined
    });
    // Ensure centralized board state is updated when board data changes
    useEffect(()=>{
        if (board && board.id === boardId) {
            dispatch(setCentralizedPublicBoardAction({
                board
            }));
        }
    }, [
        board,
        boardId,
        dispatch
    ]);
    return /*#__PURE__*/ _jsx(PublicBoard, {});
});
PublicBoardPage.displayName = "PublicBoardPage";
